import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DiscountTemplatesComponent } from './discount-templates.component';
import { CreateGeneralDiscountTemplateComponent } from './create-general-discount-template/create-general-discount-template.component';
import { EditGeneralDiscountTemplateComponent } from './edit-general-discount-template/edit-general-discount-template.component';
import { CustmizedDiscountTemplatesComponent } from './custmized-discount-templates/custmized-discount-templates.component';

const routes: Routes = [{
  path: '', component: DiscountTemplatesComponent
},
{ path: 'create-general-discount-template/:id', component: CreateGeneralDiscountTemplateComponent },
{ path: 'edit-general-discount-template/:id', component: EditGeneralDiscountTemplateComponent },
{ path: 'customized-general-discount-template/:id', component: CustmizedDiscountTemplatesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiscountTemplatesRoutingModule { }
